module.exports = __webpack_public_path__ + "img/logotipo-dark.4c592def.svg";